import { Component, Input, OnInit } from '@angular/core';
import { TotalUsage, UserStatsBundle } from 'src/app/models/statistics';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-user-stats-total-table',
  templateUrl: './user-stats-total-table.component.html',
  styleUrls: ['./user-stats-total-table.component.scss'],
})
export class UserStatsTotalTableComponent implements OnInit {
  @Input() userStatsBundle: UserStatsBundle;

  ebookTotals: TotalUsage;
  audioTotals: TotalUsage;
  videoTotals: TotalUsage;
  scormTotals: TotalUsage;

  totalItems: number;
  totalTime: string;
  totalPagesPerHour: number | string;

  constructor() {}

  ngOnInit() {
    this.getEbookTotals();
    this.getAudioTotals();
    this.getVideoTotals();
    this.getScormTotals();
    this.computeTotals();
  }

  private getEbookTotals() {
    const pagesPerHour = Util.getPagesPerHour(
      this.userStatsBundle.readingStats.totalPages,
      this.userStatsBundle.readingStats.totalTime
    );
    this.totalPagesPerHour = isNaN(pagesPerHour) ? '--' : pagesPerHour;
    this.ebookTotals = {
      totalItems: this.userStatsBundle.readingStats.totalEbooks,
      totalDedicatedHours: Util.formatTime(this.userStatsBundle.readingStats.totalTime),
      totalUnitsPerHour: this.totalPagesPerHour,
    };
  }

  private getAudioTotals() {
    this.audioTotals = {
      totalItems: this.userStatsBundle.listeningStats.totalMedia,
      totalDedicatedHours: Util.formatTime(this.userStatsBundle.listeningStats.totalTime),
    };
  }

  private getVideoTotals() {
    this.videoTotals = {
      totalItems: this.userStatsBundle.watchingStats.totalMedia,
      totalDedicatedHours: Util.formatTime(this.userStatsBundle.watchingStats.totalTime),
    };
  }

  private getScormTotals() {
    this.scormTotals = {
      totalItems: this.userStatsBundle.scormStats.totalMedia,
      totalDedicatedHours: Util.formatTime(this.userStatsBundle.scormStats.totalTime),
    };
  }

  private computeTotals() {
    this.totalItems =
      this.userStatsBundle.readingStats.totalEbooks +
      this.userStatsBundle.listeningStats.totalMedia +
      this.userStatsBundle.watchingStats.totalMedia +
      this.userStatsBundle.scormStats.totalMedia;
    this.totalTime = Util.formatTime(
      this.userStatsBundle.readingStats.totalTime +
        this.userStatsBundle.listeningStats.totalTime +
        this.userStatsBundle.watchingStats.totalTime +
        this.userStatsBundle.scormStats.totalTime
    );
  }
}
